module.exports = __webpack_public_path__ + "static/media/claire-compressed.2e23617b.png";